// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"112":"work","420":"message","539":"misc","644":"account","857":"report","884":"admin"}[chunkId] || chunkId) + "." + {"112":"aa5a6b1d","354":"892140df","420":"0f353d3a","450":"1a449579","539":"d467ef42","644":"f080ab78","775":"d2e04469","857":"5ba9359c","884":"b991cb6a","945":"825e6dec"}[chunkId] + ".js";
};